import * as React from "react";
const SvgInxTlinkicon = () => (
  <svg width={24} height={24} fill="none">
    <path
      fill="#6366F1"
      d="M15.644 14.143a.643.643 0 1 0 0 1.286h3a.643.643 0 1 0 0-1.286h-3ZM1.719 7.5a3.214 3.214 0 0 1 3.214-3.214h14.14A3.214 3.214 0 0 1 22.287 7.5v9a3.214 3.214 0 0 1-3.214 3.215H4.933A3.214 3.214 0 0 1 1.72 16.5l-.001-9Zm3.214-1.928A1.929 1.929 0 0 0 3.004 7.5v.643h17.997V7.5a1.929 1.929 0 0 0-1.928-1.928H4.933ZM3.004 16.5a1.929 1.929 0 0 0 1.929 1.929h14.14A1.929 1.929 0 0 0 21 16.5V9.43H3.005V16.5Z"
    />
  </svg>
);
export default SvgInxTlinkicon;
